import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { GoEye } from "react-icons/go";
import { RiDeleteBinLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteOrderAction,
  resetOrderState,
} from "../../redux/features/orderSlide";
import { toast } from "react-toastify";
import { format } from "timeago.js";
import { dateFormat } from "../../context/Functionalty";
import OrderingStats from "./OrderStats";

function Table({ dashboard, datas }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  console.log({ datas });
  // Styles
  const Head = "text-xs font-semibold px-6 py-2 uppercase";
  const Text = "px-5 text-sm py-3 leading-6 whitespace-nowrap";
  const badge = "py-1 px-2 rounded-full text-xs font-semibold";

  // Selectors from order slice
  const {
    loading,
    success,
    error,
    deleteSuccess, // if added in your orderSlice initialState
    orders,
  } = useSelector((state) => state.order);

  // Delete handler
  const deleteHandler = (id) => {
    if (window.confirm("This order will be deleted")) {
      dispatch(deleteOrderAction(id));
    }
  };

  // Handle errors
  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch(resetOrderState());
    }
  }, [error, dispatch]);

  // Handle delete success (optional, if you need it to reload orders)
  useEffect(() => {
    if (deleteSuccess) {
      toast.success("Order deleted successfully!");
      dispatch(resetOrderState());
    }
  }, [deleteSuccess, dispatch]);

  //pagination

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const allOrders = dashboard
    ? datas?.orders?.slice(0, 5)
    : datas?.orders || [];
  const totalPages = Math.ceil(allOrders.length / rowsPerPage);
  const paginatedOrders = allOrders.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value));
    setCurrentPage(1); // reset to first page
  };

  //stattistics section
  const total = allOrders.length;
  const upcoming = allOrders.filter(
    (o) => o.status === "active" && new Date(o.selectedDateTime) > new Date()
  ).length;
  const cancelled = allOrders.filter((o) => o.status === "cancelled").length;
  const completed = allOrders.filter(
    (o) => o.status === "active" && new Date(o.selectedDateTime) <= new Date()
  ).length;

  // Row component for table rows
  const Rows = ({ order, index }) => {
    return (
      <tr>
        <td className={`${Text} font-medium text-center`}>{index + 1}</td>

        <td className={`${Text} font-medium`}>
          xxx{order?._id?.slice(10, 15)}
        </td>
        <td className={`${Text} text-center`}>{`${dateFormat(
          order?.createdAt
        )} (${format(order?.createdAt)})`}</td>
        <td className={`${Text} text-center`}>
          {order?.payments?.paymentMethod || "---"}
        </td>
        <td className={`${Text} text-center`}>
          {order?.payments?.status === "completed" && (
            <span className={`${badge} text-green-600 bg-green-100`}>
              {order?.payments?.status}
            </span>
          )}
          {order?.payments?.status === "pending" && (
            <span className={`${badge} text-orange-600 bg-orange-100`}>
              {order?.payments?.status}
            </span>
          )}
          {order?.payments?.status === "cancelled" && (
            <span className={`${badge} text-red-600 bg-red-100`}>
              {order?.payments?.status}
            </span>
          )}
        </td>
        <td className={`${Text} font-bold text-center`}>
          ${order?.totalPrice.toFixed(1)}
        </td>
        <td className={`${Text} float-right flex gap-2`}>
          {!dashboard && (
            <button
              onClick={() => deleteHandler(order?._id)}
              className="border text-red-600 border-red-600 rounded flex-colo items-center w-6 h-6"
            >
              <RiDeleteBinLine />
            </button>
          )}
          <button
            onClick={() => navigate(`/orders/${order?._id}`)}
            className="border text-redlight border-main rounded flex-colo w-6 h-6 text-red-600 border-red-600"
          >
            <GoEye />
          </button>
        </td>
      </tr>
    );
  };

  return (
    <div className="w-full relative overflow-hidden overflow-x-auto bg-white dark:bg-neutral-800 transition-colors duration-300 scrollbar-thin scrollbar-thumb-gray-400 dark:scrollbar-thumb-neutral-600 scrollbar-track-gray-100 dark:scrollbar-track-neutral-700">
      <OrderingStats
        stats={{ total, upcoming, cancelled, completed }}
        onDeleteAll={() => {
          if (window.confirm("Are you sure you want to delete all bookings?")) {
            // dispatch(deleteAllOrdersAction());
          }
        }}
      />

      <table className="table-auto min-w-full border border-gray-300 divide-y divide-gray-200 dark:border-neutral-700 dark:divide-neutral-600 transition-colors duration-300">
        <thead>
          <tr className="bg-gray-100 dark:bg-red-500">
            <th scope="col" className={`${Head} text-left`}>
              No
            </th>

            <th scope="col" className={`${Head} text-left`}>
              ID
            </th>
            <th scope="col" className={`${Head} text-center`}>
              Date
            </th>
            <th scope="col" className={`${Head} text-center`}>
              Method
            </th>
            <th scope="col" className={`${Head} text-center`}>
              Payment Status
            </th>
            <th scope="col" className={`${Head} text-center`}>
              Total
            </th>
            <th scope="col" className={`${Head} text-end`}>
              Action
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200 dark:divide-neutral-600 dark:bg-neutral-800">
          {/* {dashboard
            ? datas?.orders
                ?.slice(0, 5)
                .map((order) => <Rows key={order?._id} order={order} />)
            : datas?.orders?.map((order, index) => (
                <Rows key={order?._id} order={order} index={index} />
              ))} */}
          {paginatedOrders.map((order, index) => (
            <Rows
              key={order?._id}
              order={order}
              index={(currentPage - 1) * rowsPerPage + index}
            />
          ))}
        </tbody>
      </table>
      <div className="flex flex-col md:flex-row items-center justify-between px-4 py-4 bg-white dark:bg-neutral-800 border-t dark:border-neutral-700 text-sm">
        {/* Result info */}
        <div className="text-gray-600 dark:text-gray-300 mb-2 md:mb-0">
          Viewing{" "}
          <span className="font-semibold text-gray-900 dark:text-white">
            {(currentPage - 1) * rowsPerPage + 1}
          </span>
          {" – "}
          <span className="font-semibold text-gray-900 dark:text-white">
            {Math.min(currentPage * rowsPerPage, allOrders.length)}
          </span>{" "}
          of{" "}
          <span className="font-semibold text-gray-900 dark:text-white">
            {allOrders.length}
          </span>{" "}
          results
        </div>

        {/* Navigation buttons */}
        <div className="flex items-center justify-center gap-2 py-4 bg-[#1e293b] rounded-md">
          {/* Previous */}
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            className={`w-8 h-8 flex items-center justify-center rounded-full text-white text-sm ${
              currentPage === 1
                ? "opacity-30 cursor-not-allowed"
                : "hover:bg-gray-600"
            }`}
          >
            &lt;
          </button>

          {/* Page numbers */}
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              onClick={() => setCurrentPage(page)}
              className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-semibold ${
                currentPage === page
                  ? "bg-redlight text-text"
                  : "text-white hover:bg-gray-600"
              }`}
            >
              {page}
            </button>
          ))}

          {/* Next */}
          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
            className={`w-8 h-8 flex items-center justify-center rounded-full text-white text-sm ${
              currentPage === totalPages
                ? "opacity-30 cursor-not-allowed"
                : "hover:bg-gray-600"
            }`}
          >
            &gt;
          </button>
        </div>
      </div>
    </div>
  );
}

export default Table;
